import { render } from "./Coursecard.vue?vue&type=template&id=ede0df24&scoped=true"
import script from "./Coursecard.vue?vue&type=script&lang=js"
export * from "./Coursecard.vue?vue&type=script&lang=js"

import "./Coursecard.vue?vue&type=style&index=0&id=ede0df24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede0df24"]])

export default __exports__